import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import TimeWindowEditCron from "@/components/time-window/edit/TimeWindowEditCron.vue";
import AssignedVisitPointList from "@/components/visit-point/list/AssignedVisitPointList.vue";
import FloatingButtons from "@/views/FloatingButtons.vue";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";

export const TimeWindowEditMixin = {
	name: "TimeWindowEdit",
	mixins: [generalPurposeMixin],
	components: {
		vSelect,
		flatPickr,
		TimeWindowEditCron,
		AssignedVisitPointList,
		FloatingButtons,
	},
	props: {
		dataTimeWindow: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			timewindow: JSON.parse(JSON.stringify(this.dataTimeWindow)),
			typeTimeWindow: {},
			cronExpresion: "",
			activeNavItem: 0,
			maximize: false,
			isSoftTimeWindow: false,
			compareDuration: false,
			durationProps: "12:00:00",
			showDateTimeEdit: new Date(),
			typeTimeWindowList: [
				{text: this.$t("TimeWindow.Daily"), value: "daily"},
				{text: this.$t("TimeWindow.Monthly"), value: "monthly"},
				{text: this.$t("TimeWindow.Weekly"), value: "weekly"},
			],
		};
	},
	mounted() {
		if (this.timewindow.hasOwnProperty("duration") && this.timewindow["duration"] !== null) {
			const [hours, minutes, seconds] = this.timewindow["duration"].split(":");
			this.hours = parseInt(hours);
			this.minutes = parseInt(minutes);
			this.seconds = parseInt(seconds);
		}
	},
	watch: {
		durationTimeWindow(val) {
			if (val) {
				this.durationProps = val;
			}
		},
	},
	computed: {
		navbarTitle() {
			if (this.activeNavItem === 0) return this.$t("Crud.Update") + " " + this.$t("TimeWindow.Schedule");
			else return this.$t("VisitPoints.Add") + " " + this.$t("Routing.Title.VisitPoints");
		},
		validateForm() {
			return !this.errors.any();
		},
		visitPointIds() {
			return this.timewindow["visit_point_id"] && this.timewindow["visit_point_id"] !== null
				? this.timewindow["visit_point_id"]
				: [];
		},
		cronExpression() {
			return this.$store.state.moduleTimeWindow.cronExpression;
		},
		soft_time_window() {
			return {
				before_soft_duration: this.timewindow.before_soft_duration,
				after_soft_duration: this.timewindow.after_soft_duration,
				before_soft_cost: parseFloat(this.timewindow.before_soft_cost),
				after_soft_cost: parseFloat(this.timewindow.after_soft_cost),
			};
		},
		durationTimeWindow() {
			return `${this.hours < 10 ? "0" + this.hours : this.hours}:${
				this.minutes < 10 ? "0" + this.minutes : this.minutes
			}:${this.seconds < 10 ? "0" + this.seconds : this.seconds}`;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		maximizeCalendar(val) {
			this.maximize = val;
		},
		getCronExpresion(val) {
			this.cronExpresion = val;
		},
		isSoftTimeWindowEmit(val) {
			this.isSoftTimeWindow = val;
		},
		compareDurationEmit(val) {
			this.compareDuration = val;
		},
		validateInputNumberMinutes(event) {
			if (this.minutes.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberSeconds(event) {
			if (this.seconds.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		update() {
			let params = {};
			this.timewindow["visit_point_id"] = this.$store.state.moduleVisitPoint.assignedVisitPoints.map(
				({id}) => id
			);
			this.timewindow["duration"] = `${this.hours < 10 ? "0" + this.hours : this.hours}:${
				this.minutes < 10 ? "0" + this.minutes : this.minutes
			}:${this.seconds < 10 ? "0" + this.seconds : this.seconds}`;
			this.timewindow["cron"] = this.$store.state.moduleTimeWindow.cronExpression;
			if (this.isSoftTimeWindow) {
				this.timewindow["soft_time_window"] = {
					before_soft_duration: this.timewindow.before_soft_duration,
					after_soft_duration: this.timewindow.after_soft_duration,
					before_soft_cost: parseFloat(this.timewindow.before_soft_cost),
					after_soft_cost: parseFloat(this.timewindow.after_soft_cost),
				};
			}
			delete this.timewindow.before_soft_duration;
			delete this.timewindow.after_soft_duration;
			delete this.timewindow.before_soft_cost;
			delete this.timewindow.after_soft_cost;
			params = {...this.timewindow};
			this.$store
				.dispatch("moduleTimeWindow/update", {id: this.timewindow.id, items: params})
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TimeWindow.Messages.TitleConfirmUpdate"),
						text: this.$t("TimeWindow.Messages.TextConfirmUpdate"),
					});
					this.$vs.loading.close();
					this.$router.push({name: "app-time-window-list"});
					return res;
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
					});
					console.error(err);
				});
		},
		submitForm() {
			this.$vs.loading();
			this.$validator.validateAll().then((result) => {
				if (result && this.isSoftTimeWindow && !this.compareDuration) {
					this.update();
				} else if (result) {
					this.update();
				} else {
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorFields.Title"),
						text: this.$t("ErrorFields.Text"),
					});
					this.$vs.loading.close();
				}
			});
		},
		getShowDate(val) {
			this.showDateTimeEdit = val;
		},
		getEvent() {
			this.timewindow.duration = this.durationTimeWindow;
			this.$refs.timeWindowEditCron.getEvents(this.cronExpression);
		},
	},
};
